<template>
    <div :class="wrapperCssClasses + ' ' + (disabled ? 'opacity-50' : '')">
        <div
            v-if="label"
            class="mb-2 block flex items-start text-[15px] text-base font-semibold"
        >
            {{ label }}
        </div>

        <label :class="labelCssClasses" v-for="option in options">
            <input
                :id="id"
                :name="name"
                :class="
                    cssClasses +
                    ' ' +
                    (disabled
                        ? ' cursor-not-allowed border-gray-400 bg-gray-50 text-gray-500'
                        : 'border-gray-200') +
                    ($page.props.errors[name] ? ' border-red-400' : '')
                "
                type="radio"
                @input="updateInput"
                :disabled="disabled"
                :value="option.value"
                :checked="option.value == modelValue"
            />
            <span v-html="option.label"></span>
        </label>

        <div class="text-[13px] text-gray-700" v-if="hint">
            {{ hint }}
        </div>

        <field-error :field-name="label" :message="$page.props.errors[name]" />
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";

export default {
    name: "FormRadio",
    components: {
        FieldError,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: null,
        },
        hint: {
            type: String,
            default: "",
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        cssClasses: {
            type: String,
            default:
                "mt-1 border-gray-50 focus:border-primary-300 focus:border mr-4",
        },
        labelCssClasses: {
            type: String,
            default:
                "pb-2 block flex items-start text-base leading-0 text-[15px]",
        },
        wrapperCssClasses: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default: [],
        },
    },
    methods: {
        updateInput(event) {
            this.$emit("update:modelValue", event.target.value);
        },
    },
};
</script>
